// extracted by mini-css-extract-plugin
export var brownTheme = "TextSection-module--brownTheme--rK--N";
export var preamble = "TextSection-module--preamble--4cyoO";
export var title = "TextSection-module--title--sgy44";
export var wrapper = "TextSection-module--wrapper--NNKeb";